import React from 'react';
import UstodaniMukadamachiMahiti from './UstodaniMukadamachiMahiti.jsx';
import KamgarInformation from './KamgarInformation.jsx';
import UsTodniKamgarStore from '../stores/UsTodniKamgarStore';
import CardDetail from './CardDetail';

var axios = require('axios');
var constants = require("../constants/constants");
const trStyle = { fontSize: '12px' }
var trstyle = {
    float: 'right',
    margin: '10px 10px 0px 0px'
}
export default class MukadamFillInfo_Show_Details extends React.Component {
    constructor(props) {
        super(props);
        let CompanyId = localStorage.getItem('CompanyId') || 1;
        this.state = {
            isMukadamInfo: false,
            isEditAction: false,
            MukadamInfo: [],
            isMukadamForm: false,
            isKamgarInformation: false,
            editMukadamData: null,
            mukadam: true,
            CompanyId: CompanyId,
            fname: ''
        };
        this.getMukadamInfo = this.getMukadamInfo.bind(this);
    }

    GetMukadamInformation() {
        var user = JSON.parse(sessionStorage.getItem("User"));
        let currentComponent = this;
        axios.get(constants.config.HOST + constants.api.GET_MUKADAM_INFORMATION, {
            params: { TransportersId: user.TransportersId, CompanyId: localStorage.getItem('CompanyId') || 1, YearId: user.TargetYearId, fname: '' }
        }).then(function (response) {
            currentComponent.setState({ MukadamInfo: response.data })
            // console.log(response.data)
        }).catch(function (error) {
            console.log(error);
        });
    }

    getMukadamInfo() {
        this.GetMukadamInformation();
    }

    componentWillMount() {
        this.GetMukadamInformation();
        UsTodniKamgarStore.addListener('Mukadam', this.getMukadamInfo);
    }

    componentWillUnmount() {
        UsTodniKamgarStore.removeListener('Mukadam', this.getMukadamInfo)
    }

    //Button method
    MukadamInfo(e) {
        this.setState({
            isMukadamInfo: true
        });
    }
    MukadamForm(e) {
        this.setState({
            isMukadamForm: true
        });
        this.props.history.push('/UstodaniMukadamachiMahiti')
    }
    KamgarInformation(e) {
        this.setState({
            isKamgarInformation: true
        });
    }

    editMukadamInfo(e, editMukadamData) {
        e.preventDefault();
        this.setState({
            editMukadamData: editMukadamData
        });
    }
    searchMukadamName(fname) {
        let currentComponent = this;
        var user = JSON.parse(sessionStorage.getItem("User"));
        axios.get(constants.config.HOST + constants.api.SEARCH_MUKADAM_NAME, {
            params: {
                TransportersId: user.TransportersId, CompanyId: localStorage.getItem('CompanyId') || 1, YearId: user.TargetYearId,
                fname: fname
            }
        })
            .then(function (response) {
                currentComponent.setState({ MukadamInfo: response.data })
            }).catch(function (error) {
                console.log(error);
            });
    }

    handleInputChange(e) {
        e.preventDefault();
        var name = e.target.name;
        var state = this.state;
        state[name] = e.target.value;
        this.setState(state);
    }

    render() {
        return (
            <div className="pages">
                <div data-page="form" className="page no-toolbar no-navbar">
                    <div className="page-content">
                        <div className="navbarpages navbarpagesbg">
                            <div className="navbar_left">
                                <h2 style={{ 'margin-top': '10px' }} ><b style={{ 'padding-left': '100px' }}>वाहतुकदार</b></h2>
                            </div>
                            <div className="navbar_right">
                                <a href="/UserProfile" className="external"><img src="images/icons/white/user.png" alt="" title="" /></a>
                            </div>
                        </div>
                        <div id="pages_maincontent">
                            <h3 style={{ margin: '0px', padding: '0px 0px 0px 80px', color: '#0000FF' }} className="Page_title"><b >मुकादमाची  माहिती </b> </h3>
                            <button type="button" style={trstyle}  className="btn btn-primary  btn-flat" style={{ margin: '5px 0px 5px 245px' }} onClick={(e) => this.MukadamForm(e)}>माहिती भरा </button>
                            <div>
                                {this.state.isMukadamForm ?
                                    <UstodaniMukadamachiMahiti isEditCall={false} /> :
                                    null
                                }
                            </div><br />
                            <div class="form_row">
                                <input type="text" class="form_input" style={{ 'margin-left': '100px', 'line-height': '25px' }} id="fname" name="fname" value={this.state.fname}
                                    onChange={(e) => this.handleInputChange(e)} placeholder="मुकादमाचे नाव शोधा.. " />

                                <button type="button" className="btn btn-info " onClick={() => this.searchMukadamName(this.state.fname)}>शोधा </button>
                            </div><br /><br />
                            <div>
                                {
                                    (this.state.MukadamInfo != null || this.state.MukadamInfo != undefined) ?
                                        this.state.MukadamInfo.map(function (Mukadam, index) {
                                            return (
                                                <CardDetail Values={Mukadam} mukadam={true} worker={false} vehicle={false} />
                                            )
                                        })
                                        : ''
                                }
                                <div>
                                    {this.state.isKamgarInformation ?
                                        <KamgarInformation name={this.state.name} /> :
                                        null
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/component/MukadamFillInfo_Show_Details.jsx